import { render } from "./VideoThumbnail.vue?vue&type=template&id=8dfae57a&ts=true"
import script from "./VideoThumbnail.vue?vue&type=script&lang=ts"
export * from "./VideoThumbnail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__